<template>
  <div class="salaryPage"  v-if="!this.showLoad">
    <div class="header">
      <p class="userName">{{salaryMsg.uidName}}，工作辛苦了！</p>
      <p class="salary">{{salaryMsg.takeHomePay}}</p>
      <p>实发金额（元）</p>
    </div>
    <div v-for="(item,index) in userData" :key="index">
        <span class="assistantTit" v-if="item.child">{{item.name}}</span>
      <van-cell-group v-if="!item.child" class="baseNone baseSalary">
        <van-cell :title="`${item.name}`" :value="`${item.value}`" class="ggInput" />
      </van-cell-group>
      <van-cell-group v-else class="baseNone baseSalary baseMargin" v-for="(itemChild,indexChild) in item.child" :key="indexChild">
        <van-cell :title="`${itemChild.name}`" :value="`${itemChild.value}`" class="ggInput" />
      </van-cell-group>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "salaryDetail",
  data() {
    return {
      salaryMonth:"",//查看的工资月份
      salaryMsg:{
        uidName:'',//名称
        takeHomePay:'',//实发金额
        content:{},//工资详情
      },
      userData:[],//工资详情数组

    };
  },
  mounted() {
    this.$nextTick(function(){
      this.salaryMonth = this.$route.query.salaryMonth; //查看的工资月份
      this.setShowLoad(false); //加载状态，默认为true加载
      this.salaryDetail()
    })
  },

  methods: {
    ...mapMutations(["setShowLoad"]),
    /*获取个人工资条详情*/
    salaryDetail(){
      let _this = this
      if(_this.salaryMonth){
        _this.$api.userCenter.user.wageList(_this.salaryMonth).then(res =>{
          if(res.code == '1' && res.data !=null){
            _this.salaryMsg = res.data
            // for(let i in res.data.content){
            //   _this.userData.push({
            //     name:i,
            //     value:res.data.content[i]
            //   })
            // }
            let content=JSON.parse(res.data.content);
            for(var i=0;i<content.length;i++){
              let obj=content[i];
              for(let key in obj){
                _this.userData.push({
                  name:key,
                  value:obj[key]
                  })
              } 
            }
          }else{
            _this.$toast(res.msg)
          }
        }).catch(err =>{
          _this.$toast(err)
        })
      }else{
        _this.$toast('未获取到正确的查询时间')
      }
    },
  },
   computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.salaryPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  font-family: " PingFangSC-Medium", "PingFang SC";
  .ggInput {
    height: 45px;
    .van-cell__title{
      color: #666;
      font-size: 14px;
    }
    .van-cell__value {
      span {
        font-size: 16px;
        color: #333;
      }
    }
    .van-cell__right-icon {
      color: #000;
      margin-left: 8px;
    }
  }
  .ggMargin {
    margin-top: 12px;
  }
  .baseNone::after {
    content: none;
  }
  .header {
    width: 100%;
    height: 195px;
    padding-top: 20px;
    background-color: #3c78f9;
    p {
      text-align: center;
      color: #fff;
    }
    p:last-child {
      text-align: center;
      opacity: 0.6;
    }
    .userName {
      font-size: 14px;
      font-weight: bold;
      line-height: 20px;
    }
    .salary {
      margin-top: 20px;
      font-size: 32px;
      font-weight: bold;
      line-height: 45px;
    }
  }
   
  .baseSalary {
    margin-top: 12px;
    height: 45px;
    line-height: 45px;
  }
  .baseMargin.baseMargin{
     margin-top: 0;
     margin-bottom: 12px;
  }
  .assistantTit {
    display: block;
    width: 100%;
    height: 38px;
    line-height: 38px;
    color: #727272;
    padding-left: 15px;
  }
}
</style>